export const defaultConfigs = {
    checkoutUrl: '/',
    displayGiftwrapItemsInCart: false,
    enableDiscountModule: true,
    enableDonations: false,
    enableEstimatedTotals: true,
    enableKitDetails: false,
    enableOfferCodeModule: false,
    enableOffersTab: true,
    enableRecommendedForYou: false,
    enableReplenishment: false,
    enabled: true,
    goShoppingUrl: '/',
    isReadOnly: false,
    itemMaxQuantity: '',
    collection: {
        enabled: true,
        collectionName: 'favorites'
    },
    offersCarouselRules: [
        {
            enabled: 0,
            maxDisplayThreshold: '',
            minDisplayThreshold: '',
            offerTypesToShow: '',
            ruleType: '',
            sortOrder: ''
        },
        {
            enabled: 1,
            maxDisplayThreshold: '100',
            minDisplayThreshold: '0',
            offerTypesToShow: 'gwp,pwp,evergreen,samples',
            ruleType: 'Check Next Offer',
            sortOrder: '1'
        },
        {
            enabled: 1,
            maxDisplayThreshold: '100',
            minDisplayThreshold: '0',
            offerTypesToShow: 'gwp,pwp,evergreen',
            ruleType: 'Check Next Offer',
            sortOrder: '2'
        }
    ]
};
